// third party
import * as yup from 'yup';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        metadata: yup
            .object()
            .shape({
                transitions: yup
                    .array()
                    .of(
                        yup
                            .object()
                            .shape({
                                transition: yup.string().nullable(),
                                canBeExecutedManually: yup.boolean().nullable(),
                                executeChildrenTransitions: yup.array().of(yup.string()).nullable()
                            })
                            .nullable()
                    )
                    .nullable()
            })
            .nullable()
    });

export default validationSchema;
